import StoryContainer from 'components/Story/StoryContainer'
import StoryData from 'components/Story/StoryData'
import StoryPresentation from 'components/Story/StoryPresentation'
import StoryPresentationDrawer from 'components/Story/StoryPresentationDrawer'

export default {
  Container: StoryContainer,
  Data: StoryData,
  Presentation: StoryPresentation,
  PresentationDrawer: StoryPresentationDrawer,
}
